"use client"

import { useEffect } from "react"

function isEditableField(target: EventTarget | null): target is HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement {
  return (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement
  )
}

export function usePreventSheetKeyboard(open: boolean) {
  useEffect(() => {
    if (!open || typeof window === "undefined") return

    const active = document.activeElement
    if (active instanceof HTMLElement) {
      active.blur()
    }

    let unlocked = false
    const unlock = () => {
      unlocked = true
    }

    const handleFocusIn = (event: FocusEvent) => {
      if (unlocked) return
      const target = event.target
      if (!isEditableField(target)) return
      if (target instanceof HTMLInputElement && target.readOnly) return
      target.blur()
    }

    window.addEventListener("pointerdown", unlock, { capture: true })
    window.addEventListener("touchstart", unlock, { capture: true, passive: true })
    document.addEventListener("focusin", handleFocusIn, true)
    const timer = window.setTimeout(unlock, 500)

    return () => {
      unlocked = true
      window.clearTimeout(timer)
      window.removeEventListener("pointerdown", unlock, { capture: true })
      window.removeEventListener("touchstart", unlock, { capture: true })
      document.removeEventListener("focusin", handleFocusIn, true)
    }
  }, [open])
}
